import * as React from "react";
import { observer } from "mobx-react-lite";
import { Mc2EntityStore } from "../Mc2EntityStore";
import { Mc2ImageInternal } from "./Mc2ImageInternal";
import styles from "./Mc2ImageView.module.less";

interface PropsMcImageView {
  store: Mc2EntityStore;
}

/**
 * @deprecated Теперь есть общий компонент ResizableHorizPart
 */
export const Mc2ImageView: React.FC<PropsMcImageView> = observer(
  ({ store }) => {
    const ref = React.useRef<HTMLDivElement>(null);
    const onDragStart: React.DragEventHandler = (e) => {
      store.setImgX0(e.clientX + (ref.current?.clientWidth ?? 0));
    };
    const onDrag: React.DragEventHandler = (e) => {
      store.setImgWidth(store.imgX0 - e.clientX);
    };
    return (
      <div
        ref={ref}
        className={styles.imgViewBox}
        style={{ width: store.imgWidth }}
      >
        <div
          className={styles.drag}
          draggable
          onDragStart={onDragStart}
          onDrag={onDrag}
          onDragEnd={onDrag}
        >
          <div className={styles.dragCenter} />
        </div>
        <div className={styles.body}>
          <Mc2ImageInternal store={store} />
        </div>
      </div>
    );
  },
);
